<template>
    <tr class="has-details" :class="{'shown': isSelected}" @click="onRowClick(user.id)">
        <td>{{ user.id }}</td>
        <td>{{ userFullName }}</td>
        <td>{{ user.email }}</td>
        <td>{{ userPhoneNumber }}</td>
        <!-- <td class="text-center" :inner-html.prop="!user.archived | bool-icon"></td> -->
    </tr>
</template>

<script>
    export default {
        data() {
            return {}
        },

        props: {
            user: {
                required: true
            },
            isSelected: {
                type: Boolean,
                required: true
            }
        },

        computed: {
            userFullName() {
                let fullName = ''

                if (this.user.first_name) {
                    fullName += this.user.first_name
                }

                if (this.user.last_name) {
                    if (fullName) {
                        fullName += ' '
                    }
                    fullName += this.user.last_name
                }

                return fullName ? fullName : '-'
            },

            userPhoneNumber() {
                return this.user.phone ? this.user.phone : '-'
            }
        },

        methods: {
            onRowClick(userId) {
                this.$emit("row-clicked", userId)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Users/UserRowItem.vue